import {
  DEFAULT_SETTINGS_FONTS,
  ISettingsFont,
  ISettingsFonts,
} from '@wix/podcasts-common/dist/settings';
import { IStyleParamsFont } from '@wix/podcasts-common/dist/style-params';
import { IThemeFonts } from '../../types';

function fontsByTheme(
  defaultFonts: { [key: string]: IStyleParamsFont },
  themeFonts: IThemeFonts,
): Record<string, ISettingsFont> {
  const fonts: Record<string, ISettingsFont> = {};

  Object.keys(defaultFonts).forEach((key) => {
    const font = defaultFonts[key];
    const themeFontPreset = font.preset;
    const themeFont = themeFonts[themeFontPreset];

    if (!themeFont) {
      console.warn(`theme font is not found for default font:`, {
        [key]: defaultFonts[key],
      });
      return;
    }

    fonts[key] = {
      ...font,
      family: themeFont.fontFamily,
    };
  });

  return fonts;
}

function getSettingsFontsByTheme(themeFonts: IThemeFonts): ISettingsFonts {
  return {
    main: fontsByTheme(DEFAULT_SETTINGS_FONTS.main, themeFonts),
    episode: fontsByTheme(DEFAULT_SETTINGS_FONTS.episode, themeFonts),
    common: fontsByTheme(DEFAULT_SETTINGS_FONTS.common, themeFonts),
  };
}

export default getSettingsFontsByTheme;
